import { isUuid } from './uuid';

import type { Split, ValueOf } from '../types';

export type GetDynamicPathParam<R extends string> = Extract<ValueOf<Split<R, '/'>>, `[${string}]`>;
export type GetDynamicPathParamKeys<R extends string> =
  GetDynamicPathParam<R> extends `[${infer ID}]` ? ID : never;
/**
 * Route를 path로 구성합니다. 필요한 params가 있다면 args 타입을 제공해줍니다.
 *
 * @example
 * <Link href={getRouterPath(ROUTE_PATH.SUBNET_DETAIL, )}>...</Link>
 * "/vpc/subnets/[subnetId]/detail" -> "/vpc/subnets/hello-world/detail"
 */
export const getRouterPath = <R extends string>(
  key: R,
  ...args: GetDynamicPathParam<R> extends never
    ? []
    : GetDynamicPathParam<R> extends `[${infer ID}]`
      ? [params: Record<ID, string>]
      : []
): string => {
  const [params] = args;
  return key.replace(
    /\[[a-zA-Z1-9\-_]+\]/g,
    paramKey => params?.[paramKey.replace(/(^\[|\]$)/g, '')] ?? 'null',
  );
};

export const DYNAMIC_SEGMENT_PATTERN = /^(?:\d+|[0-9a-f]{24,}|[a-zA-Z0-9_-]{40,})$/;

export const isDynamicRouteSegment = (segment: string) =>
  isUuid(segment) || DYNAMIC_SEGMENT_PATTERN.test(segment);
